<template>
  <div class="base-form p-0">
    <h2 class="text-center py-2" style="color: black">Order Items</h2>
    <div class="dispatch-table-container">
      <b-table
        hover
        no-local-sorting
        small
        :items="data"
        :fields="orderItemsOptions"
        @row-clicked="onRowClicked"
      >
        <template #cell(info)="row">
          <div class="dispatch-status" :class="statusClass(row.item)" />
        </template>
        <template #cell(orderId)="row">
          <router-link
            :to="`/orders/${row.item.network_order.id}`"
            target="_blank"
          >
            {{ row.item.network_order.number }}
          </router-link>
        </template>
        <template #cell(fulfillmentCenter)="row">
          {{ row.item.fulfillment_center.name }}
        </template>
        <template #cell(kitchenReadyTime)="row">
          {{
            row.item.network_order.delivery.kitchen_ready_time
              | formatDateTimeNoYear
          }}
        </template>
        <template #cell(name)="row" :title="row.item.name">
          {{ row.item.name }}
        </template>
      </b-table>
    </div>
    <b-row align-h="between">
      <b-col class="pl-4">
        <p class="table-results my-2">
          Displaying {{ paginationFrom }}-{{ paginationTo }} of
          {{ rows }} results
        </p>
      </b-col>
      <b-col v-if="rows > queryFilters.limit" class="pr-4 mt-2">
        <b-pagination
          v-model="page"
          class="float-right"
          :total-rows="rows"
          :per-page="queryFilters.limit"
          aria-controls="my-table"
          @input="onPaginate"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  data() {
    return {
      data: [],
      rows: 0,
      paginationFrom: null,
      paginationTo: null,
      page: 1,
      queryFilters: {},
      busy: true,

      orderItemsOptions: [
        {
          key: 'info',
          label: '',
          sortable: false,
          thStyle: { width: '40px' },
        },
        {
          key: 'orderId',
          label: 'Order ID',
          sortable: false,
          thStyle: { width: '70px' },
        },
        {
          key: 'kitchenReadyTime',
          label: 'Kitchen Ready',
          sortable: false,
          thStyle: { width: '125px' },
        },
        {
          key: 'fulfillmentCenter',
          label: 'Kitchen',
          sortable: false,
        },
        {
          key: 'name',
          label: 'Item',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('session', ['filters']),
  },
  mounted() {
    this.setStoreFilters();
    this.onPaginate(this.page);
  },
  methods: {
    statusClass(item) {
      if (this.showGrayStatus(item)) {
        return { 'dispatch-status--gray': true };
      }

      return {
        'dispatch-status--green': item.dispatch_status === 2,
        'dispatch-status--yellow': item.dispatch_status === 1,
        'dispatch-status--red': item.dispatch_status === 0,
      };
    },
    setStoreFilters() {
      this.queryFilters = {
        network: this.filters.network ? this.filters.network : null,
        brand: this.filters.brand ? this.filters.brand : null,
        facility: this.filters.hub ? this.filters.hub : null,
        dispatchStatus: this.filters.status ? this.filters.status : null,
        number: this.filters.number ? this.filters.number : null,
        delivery: this.filters.delivery ? this.filters.delivery : null,
        search: this.filters.search ? this.filters.search : null,
        limit: this.filters.limit ? this.filters.limit : 50,
        sort: this.filters.sort ? this.filters.sort : '',
        dir: this.filters.dir ? this.filters.dir : '',
      };

      this.range = {
        ...this.filters.range,
      };
    },
    onPaginate(page) {
      this.page = page;
      this.loadResults();
    },
    onSortingChanged(ctx) {
      this.queryFilters.sort = ctx.sortBy;
      this.queryFilters.dir = ctx.sortDesc ? 'DESC' : 'ASC';
      this.loadResults();
    },
    loadResults() {
      const me = this;

      me.busy = true;

      this.setStoreFilters();

      // Format search params for query
      const searchParams = {
        ...this.queryFilters,
        range: this.range,
        page: this.page,
      };
      searchParams.dispatchStatus = searchParams.dispatchStatus
        ? searchParams.dispatchStatus.value
        : null;
      searchParams.fulfillmentCenter = searchParams.kitchen
        ? searchParams.kitchen.id
        : null;
      searchParams.network = searchParams.network
        ? searchParams.network.id
        : null;
      searchParams.deliveryProvider = searchParams.provider
        ? searchParams.provider.id
        : null;
      searchParams.with = 'networkOrder.delivery,fulfillmentCenter';
      searchParams.facility = searchParams.facility
        ? searchParams.facility.id
        : null;
      searchParams.number = searchParams.number ? searchParams.number : null;
      searchParams.delivery = searchParams.delivery
        ? searchParams.delivery
        : null;
      searchParams.start = me.formatDateFilter(searchParams.range.start);
      searchParams.end = me.formatDateFilter(searchParams.range.end);
      searchParams.range = null;
      searchParams.kitchen = null;
      searchParams.provider = null;
      searchParams.excludeSource = 'zdm-test';

      return ResourceAPI.getRecords('dispatch/order-items', searchParams)
        .then((data) => {
          me.rows = data.meta.total;
          me.data = data.data;
          me.paginationFrom = data.meta.from;
          me.paginationTo = data.meta.to;
          me.busy = false;
        })
        .catch((error) => alert(error));
    },

    onRowClicked(record) {
      this.page = 1;
      this.$emit('filterDelivery', record.network_order.delivery.id);
    },

    showGrayStatus(item) {
      const showTimeStatuses = ['placed', 'confirmed', 'preparing'];
      return !showTimeStatuses.includes(item.status);
    },
  },
};
</script>
